import { Check, Shield, FileText, AlertTriangle, Download } from "lucide-react";
import { CTAButton } from "../shared/CTAButton";
import { AnimatedSection } from "../shared/AnimatedSection";
const ChecklistPreviewCards = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    formElement?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const categories = [{
    icon: Shield,
    title: "IT-Sicherheit",
    subtitle: "Technische Schutzmaßnahmen",
    features: ["2FA-Authentifizierung", "3-2-1 Backup-Strategie", "Security-Updates", "Firewall & Virenschutz", "Passwort-Richtlinien"]
  }, {
    icon: FileText,
    title: "DSGVO-Compliance",
    subtitle: "DSGVO-konform",
    features: ["DSGVO-Dokumentation", "Meldepflichten 72h-Regel", "Verschlüsselung", "Verarbeitungsverzeichnis", "AVV-Verträge"]
  }, {
    icon: AlertTriangle,
    title: "Notfall-Management",
    subtitle: "Für den Ernstfall vorbereitet",
    features: ["Cyber-Notfallplan", "Incident Response Team", "Wiederherstellungsplan", "Kommunikationsstrategie", "Notfall-Übungen"]
  }];
  return <section className="py-20 sm:py-28 lg:py-32 relative">
      {/* Dezenter Gradient Overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at top, hsl(var(--accent) / 0.06), transparent 60%)"
    }} />
      
      <div className="container max-w-6xl mx-auto px-6 sm:px-8 relative z-10">
        
        {/* Header */}
        <AnimatedSection delay={0} className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Was Sie in der <span className="text-accent">Checkliste</span> erwartet
          </h2>
          <p className="text-xl sm:text-2xl text-muted-foreground max-w-3xl mx-auto">
            13 sofort umsetzbare Maßnahmen zum Schutz Ihrer Praxis
          </p>
        </AnimatedSection>
        
        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((category, idx) => {
            const IconComponent = category.icon;
            return (
              <AnimatedSection 
                key={idx} 
                delay={0.2 + (idx * 0.15)}
                viewport={{ once: true, margin: "-50px" }}
              >
                <div className="border border-white/10 p-6 backdrop-blur-sm hover:border-accent/50 transition-all text-center rounded-lg h-full">
                  <div className="mb-5">
                    <IconComponent className="w-8 h-8 text-accent mb-3 mx-auto" />
                    <h3 className="text-xl font-bold mb-2">{category.title}</h3>
                    <p className="text-sm text-muted-foreground whitespace-pre-line">{category.subtitle}</p>
                  </div>
                  
                  <ul className="space-y-2.5">
                    {category.features.map((feature, featureIdx) => (
                      <li key={featureIdx} className="flex items-start gap-2.5">
                        <Check className="w-4 h-4 text-accent flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-foreground/90">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
        
        {/* Zentrierter CTA */}
        <AnimatedSection delay={0.7} className="mt-12 text-center">
          <CTAButton onClick={scrollToForm} icon={Download}>
            Jetzt kostenlos herunterladen
          </CTAButton>
        </AnimatedSection>
      </div>
    </section>;
};
export default ChecklistPreviewCards;